module.exports = __webpack_public_path__ + "img/6_133.8edc5cfb.png";